/** Possible sources of a location (latitude and longitude). */
const GPS = 'GPS';
const ADDRESS = 'ADDRESS';

export default {
  GPS,
  ADDRESS,
};
